module.exports = __webpack_public_path__ + "static/media/AsYouWalkonBy.f508c52a.jpg";